import { gql } from "@apollo/client";
import { graph } from "config/axios-context";
import {
    DeleteHarvestAgricultureWorkMutation,
    DeleteHarvestAgricultureWorkMutationVariables,
    DeleteHarvestAgricultureWorkTemplateMutation,
    DeleteHarvestAgricultureWorkTemplateMutationVariables,
    HarvestAgricultureWorkFilterInput,
    HarvestAgricultureWorkTemplateFilterInput
} from "types/graphql";

const deleteWorkMutationDocument = gql`
mutation DeleteHarvestAgricultureWork($id: Int, $where: HarvestAgricultureWorkFilterInput) {
    harvestAgricultureWorkDelete(id:$id, where:$where) 
  }
`

export async function deleteWorkMutation(condition: number | HarvestAgricultureWorkFilterInput) {
    try {
        const response = await graph<DeleteHarvestAgricultureWorkMutation, DeleteHarvestAgricultureWorkMutationVariables>({
            query: deleteWorkMutationDocument,
            variables: {
                id: typeof condition === 'number' ? condition : undefined,
                where: typeof condition !== 'number' ? condition : undefined
            }
        })

        if(response.errors?.length) {
            throw response.errors
        }

        return response.data?.harvestAgricultureWorkDelete;
    } catch (error) {
        throw error;
    }
}


// #region delete harvest template
const deleteHarvestTemplate = gql`
mutation DeleteHarvestAgricultureWorkTemplate($id: Int, $where: HarvestAgricultureWorkTemplateFilterInput) {
    harvestAgricultureWorkTemplateDelete(id:$id, where:$where) 
}
`;

export async function deleteHarvestTemplateMutation(condition: number | HarvestAgricultureWorkTemplateFilterInput) {
    try {
        const response = await graph<DeleteHarvestAgricultureWorkTemplateMutation, DeleteHarvestAgricultureWorkTemplateMutationVariables>({
            query: deleteHarvestTemplate,
            variables: {
                id: typeof condition === 'number' ? condition : undefined,
                where: typeof condition !== 'number' ? condition : undefined
            }
        })

        if(response.errors?.length) {
            throw response.errors
        }

        return response.data?.harvestAgricultureWorkTemplateDelete;
    } catch (error) {
        throw error;
    }
}
// #endregion
